import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaCircle } from "react-icons/fa";
import { IoMdSearch } from "react-icons/io";
import MyOrderProductCard from "../../components/Orders/MyOrderProductCard";
import { BASE_URL, USER_URL } from "../../constant/api";
import { Link } from "react-router-dom";
import CustomerReview from "../../components/CustomerReview/CustomerReview";
import SearchInput from "../../components/Home/SearchInput/SearchInput";
import img from "../../assets/seller/loading.png";
function MyOrders() {
  const [filter, setFilter] = useState("All");
  const [orders, setOrders] = useState([]);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [fastMovingProducts, setFastMovingProducts] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const isCartEmpty = orders.length === 0;

  // Open and close popup
  const openPopup = (orderId) => {
    setSelectedOrderId(orderId);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedOrderId(null);
  };

  // Fetch orders dynamically based on the filter
  const fetchOrders = async () => {
    // const token = localStorage.getItem("token");
    // const headers = { Authorization: `JWT ${token}` };

    // Map filter to respective URLs
    // const filterUrls = {
    //   All: `${BASE_URL}/orders/`,
    //   Pending: `${BASE_URL}/orders/?status=pending`,
    //   Delivered: `${BASE_URL}/orders/?status=delivered`,
    //   Cancelled: `${BASE_URL}/orders/?status=cancelled`,
    // };
    const filterUrls = {
      All: `/orders/`,
      Pending: `/orders/?status=pending`,
      Delivered: `/orders/?status=delivered`,
      Cancelled: `/orders/?status=cancelled`,
    };

    try {
      const response = await USER_URL.get(filterUrls[filter]);
      setOrders(response.data.Data || []); // Adjust based on API response structure
    } catch (error) {
      console.error(`Error fetching ${filter} orders:`, error);
    }
  };

  // Fetch orders whenever the filter changes
  useEffect(() => {
    fetchOrders();
  }, [filter]);
  console.log(orders);

  // Fetch Trending and Fast-Moving Products
  useEffect(() => {
    const fetchData = async (url, setter) => {
      try {
        const response = await axios.get(url);
        setter(response.data.Data || []); // Adjust based on API response structure
      } catch (error) {
        console.error(`Error fetching data from ${url}:`, error);
      }
    };

    fetchData(`${BASE_URL}/products/trending/`, setTrendingProducts);
    fetchData(`${BASE_URL}/products/fast-moving/`, setFastMovingProducts);
  }, []);
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  // // Filter the orders safely based on searchQuery
  // const filteredOrders = orders.filter(item =>
  //   item.product_name?.toLowerCase().includes(searchQuery) || false
  // );

  return (
    <div className="container mx-auto border-t-2">
      <div className="ml-5 mt-5">
        <SearchInput
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search items..."
          head="My Orders"
        />
      </div>

      <div className="flex flex-col gap-1 p-4 md:flex-row">
        {/* Sidebar with Filters */}
        <div className="w-full p-2 md:w-1/6">
          <div className="rounded-lg border-2 p-3 font-medium shadow-md">
            {["All", "Pending", "Delivered", "Cancelled"].map((status) => (
              <label
                key={status}
                className="ml-3 flex cursor-pointer items-center gap-3 p-1"
              >
                <input
                  type="radio"
                  value={status}
                  checked={filter === status}
                  onChange={() => setFilter(status)}
                  className="peer hidden"
                />
                <span
                  className={`flex h-5 w-5 items-center justify-center rounded-full border ${
                    filter === status
                      ? "border-green-500 bg-green-500"
                      : "border-gray-300 bg-white"
                  } peer-checked:border-green-500 peer-checked:bg-white`}
                >
                  {filter === status && (
                    <FaCircle className="size-3 text-green-500" />
                  )}
                </span>
                <span
                  className={`text-xs ${
                    filter === status ? "text-green-500" : "text-gray-700"
                  }`}
                >
                  {status}
                </span>
              </label>
            ))}
          </div>

          {/* Trending Products Section */}
          <div className="mt-5 hidden md:block">
            <MyOrderProductCard
              products={trendingProducts}
              title="Trending Products"
              layout="vertical-3-scroll"
            />
          </div>
        </div>

        {/* Main Content - Orders */}
        <div className="w-full flex-1">
          {isCartEmpty ? (
            <div className="mt-16 flex w-full flex-col items-center justify-center space-y-4">
              <img
                src={img}
                alt="Cart is empty"
                className="w-52 object-cover"
              />
              <h2 className="text-2xl font-medium text-gray-700">
                Your Orders Are Empty!
              </h2>
              <Link
                to="/"
                className="mt-4 w-[50%] rounded-lg bg-green-600 py-2 text-center text-white"
              >
                Go To Home
              </Link>
            </div>
          ) : (
            <div className="mt-3 grid max-h-[1055px] gap-4 overflow-y-scroll sm:w-full sm:gap-4">
              {orders.filter((item) =>
                item.name?.toLowerCase().includes(searchQuery.toLowerCase()),
              ).length > 0 ? (
                orders
                  .filter((item) =>
                    item.name
                      ?.toLowerCase()
                      .includes(searchQuery.toLowerCase()),
                  )
                  .map((order, index) => (
                    <div
                      key={index}
                      className="flex flex-col rounded-lg border-2 p-4 text-xs shadow-sm sm:p-4 sm:text-sm"
                    >
                      <Link
                        to={`/orders/${order.order_number}/${order.id}`}
                        state={{ order }}
                        className="flex flex-col"
                      >
                        <div className="flex gap-4 sm:flex-row sm:gap-4">
                          <div className="h-16 w-16 sm:h-16 sm:w-16">
                            <img
                              src={
                                order.product_images?.[0]?.image
                                  ? order.product_images[0].image.startsWith(
                                      BASE_URL,
                                    )
                                    ? order.product_images[0].image
                                    : `${BASE_URL}${order.product_images[0].image}`
                                  : "/images/default-product.png"
                              }
                              alt="Product"
                              className="mt-4 size-20"
                            />
                          </div>
                          <div className="grid flex-1 grid-cols-2 gap-2 sm:grid-cols-2 md:grid-cols-4">
                            {/* Order Details */}
                            <div>
                              <p className="mb-1 text-xs font-semibold">
                                Order Number
                              </p>
                              <p className="overflow-hidden text-ellipsis whitespace-nowrap rounded border border-black p-1 text-xs">
                                {order.order_number || "N/A"}
                              </p>
                            </div>
                            <div>
                              <p className="mb-1 text-xs font-semibold">
                                Product Name
                              </p>
                              <p className="overflow-hidden text-ellipsis whitespace-nowrap rounded border border-black p-1 text-xs">
                                {order.name || "N/A"}
                              </p>
                            </div>
                            <div>
                              <p className="mb-1 text-xs font-semibold">
                                Delivery Location
                              </p>
                              <p className="overflow-hidden text-ellipsis whitespace-nowrap rounded border border-black p-1 text-xs">
                                {order.delivery_to || "N/A"}
                              </p>
                            </div>
                            <div>
                              <p className="mb-1 text-xs font-semibold">
                                Amount
                              </p>
                              <p className="overflow-hidden text-ellipsis whitespace-nowrap rounded border border-black p-1 text-xs">
                                {order.currency_symbol}{order.subtotal || "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Link>
                      <div className="ml-20 grid grid-cols-2 gap-2 sm:grid-cols-4">
                        <div>
                          <p className="mb-1 text-xs font-semibold">
                            Order Date
                          </p>
                          <p className="overflow-hidden text-ellipsis whitespace-nowrap rounded border border-black p-1 text-xs">
                            {order.order_date || "N/A"}
                          </p>
                        </div>
                        <div>
                          <p className="mb-1 text-xs font-semibold">
                            Delivery Date
                          </p>
                          <p className="overflow-hidden text-ellipsis whitespace-nowrap rounded border border-black p-1 text-xs">
                            {order.delivery_date || "N/A"}
                          </p>
                        </div>
                        <div>
                          <p className="mb-1 text-xs font-semibold">Status</p>
                          <p
                            className={`overflow-hidden text-ellipsis whitespace-nowrap rounded border border-black p-1 text-center text-xs ${
                              order.order_status === "3"
                                ? "bg-green-100 text-green-600"
                                : order.order_status === "0"
                                  ? "bg-yellow-100 text-yellow-600"
                                  : order.order_status === "4"
                                    ? "bg-red-100 text-red-600"
                                    : "bg-white"
                            }`}
                          >
                            {order.order_status === "0"
                              ? "Pending"
                              : order.order_status === "1"
                                ? "Order Confirmed"
                                : order.order_status === "2"
                                  ? "Shipped"
                                  : order.order_status === "3"
                                    ? "Delivered"
                                    : order.order_status === "4"
                                      ? "Cancelled"
                                      : "Unknown Status"}
                          </p>
                        </div>
                        <div>
                          {order.order_status === "3" && (
                            <p
                              onClick={() => openPopup(order.id)}
                              className="mt-5 cursor-pointer rounded border border-blue-600 bg-blue-500 p-1 text-center text-xs font-semibold text-white shadow transition-all duration-200 hover:bg-blue-600"
                            >
                              Add Review
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
              ) : (
                <div className="mt-5 text-center text-gray-500">
                  <p>No matching orders found</p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Fast-Moving Products Section */}
        <div className="w-full p-2 md:w-1/3">
          <MyOrderProductCard
            products={fastMovingProducts}
            title="Fast Moving Items"
            layout="vertical-3-horizontal-2"
          />
        </div>
      </div>

      {/* Popup for Customer Review */}
      <CustomerReview
        isOpen={isPopupOpen}
        onClose={closePopup}
        orderId={selectedOrderId}
      />
    </div>
  );
}

export default MyOrders;
